import Modal from '@components/Modal/Modal';
import React, { useRef, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { selectLogOut } from '@store/selectors/widgets.selectors';
import { NavigationOptions } from '@types';
import { useDispatch, useSelector } from 'react-redux';
import { AlertIconWrapper, CloseBtn, ModalContent, TextWrapper } from '@components/Modal/Modal.style';
import colors from '@theme/core/colors';
import { AmplifyLogs, UIConstants } from '@constants';
import Text from '@components/Text/Text';
import Button from '@components/Button/Button';
import { logOutAction } from '@store/actions/logout.actions';
import { auth, config } from '../../config';
import { clearCookie } from '@utils/cookieHelper';
import { callDeleteOkta } from '@services/AccountConnectFormService';
import { logUserEvent } from '@analytics/amplifyLogging';

const IdleTimerContainer: React.FC = () => {
    const dispatch = useDispatch();
    const [modalOpen, setModalOpen] = useState(false);
    const sessionTimeOutRef = useRef(null);
    const logOut: NavigationOptions = useSelector(selectLogOut);

    const handleOnIdle = () => {
        setModalOpen(true);
        sessionTimeOutRef.current = setTimeout(handleLogOut, Number(config.env('sessionTimeout')) * 60 * 1000);
    };

    useIdleTimer({
        timeout: Number(config.env('sessionIdleTime')) * 60 * 1000,
        events: ['mousemove', 'keydown', 'mousewheel', 'mousedown', 'touchstart', 'touchmove'],
        onIdle: handleOnIdle
    });

    const handleStayIn = () => {
        setModalOpen(false);
        clearTimeout(sessionTimeOutRef.current);
    };

    const handleLogOut = async () => {
        setModalOpen(false);
        clearTimeout(sessionTimeOutRef.current);
        dispatch(logOutAction());
        try {
            await auth.getOkta().signOut();
            auth.getOkta().tokenManager.clear();
            await callDeleteOkta(config.env('oktaBaseUrl'));
            clearCookie();
            //window.location.href = logOut?.url.startsWith('https://') ? logOut?.url : config.env('accountConnectLogout');
        } catch (error) {
            logUserEvent({
                type: 'Session logout',
                description: `Logout failed during session timeout with ${JSON.stringify(error)}`,
                action: 'LogoutFailedDuringSessionTimeout'
            });
        } finally {
            auth.getOkta().tokenManager.clear();
            clearCookie();
            //window.location.href = logOut?.url.startsWith('https://') ? logOut?.url : config.env('accountConnectLogout');
        }
    };

    return (
        <div>
            {modalOpen && (
                <Modal id="modal">
                    <CloseBtn id="closeBtn" onClick={handleStayIn}>
                        <img
                            src="https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/b08f0e6d-bfc2-4e54-88c2-e833c025fdc3/renditions/dfd1efbf-ec0a-49b6-b3ab-bad49d99dbdd?binary=true"
                            alt="close"
                        />
                    </CloseBtn>
                    <ModalContent id="modalContent">
                        <AlertIconWrapper>
                            <img
                                src="https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/bf019980-0330-4eae-8ee0-5f42a39a8915/renditions/583f9aea-6b39-42ca-b3fa-4005d893bb4e?binary=true"
                                alt="alert"
                            />
                        </AlertIconWrapper>
                        <TextWrapper id="warningText">
                            <Text textColor={colors.pureBlack} textVariant="text1">
                                {UIConstants.timeOut}
                            </Text>
                        </TextWrapper>
                        <Button
                            text={UIConstants.stayInSession}
                            width="19.063rem"
                            variant="solid"
                            fontWeight="Medium"
                            textTransform="none"
                            mobileWidth="17.5rem"
                            onClick={handleStayIn}
                            eventAttributes={AmplifyLogs.idleTimerModal}
                        />
                    </ModalContent>
                </Modal>
            )}
        </div>
    );
};

export default IdleTimerContainer;
